<span>{{ label }}</span>
<div>
    <ng-container *ngFor="let datum of data">
        <input type="radio" value="false" [id]="datum.id" [name]="datum.name">
        <label class="{{ datum.type }}" [for]="datum.id" (click)="onSort(datum.type)"></label>
    </ng-container>
</div>
